import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { AppBar, Avatar, Button, Snackbar, Toolbar, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import MainMenu from '../../components/Layout/MainMenu';
import Notifications from '../Notifications';
import { actions } from '../../store';
import BroadcastDialog from './BroadcastDialog';



const drawerWidth = 240;

const styles = theme => ({
	root: {
		width: '100%',
		height: '100%',
		marginTop: 0,
		zIndex: 1,
		overflow: 'hidden',
	},
	appFrame: {
		position: 'relative',
		display: 'flex',
		width: '100%',
		height: '100%',
	},
	appBar: {
		position: 'absolute',
		zIndex: theme.zIndex.navDrawer + 1,
		transition: theme.transitions.create([ 'width', 'margin' ], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		background: theme.palette.primary[ 400 ],
		//borderBottom: '3px solid' + theme.palette.primary[200],
	},
	appBarAuth: {
		marginLeft: 56,
		width: `calc(100% - 56px)`,
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create([ 'width', 'margin' ], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginLeft: 12,
		marginRight: 36,
	},
	flex: {
		flex: 1,
	},
	avatar: {
		marginTop: -8,
		marginBottom: -8,
		marginRight: 8,
		backgroundColor: 'darkred',
		width: 40,
		height: 40,
	},
	userButton: {
		textTransform: 'none',
		color: '#ffffff',
	},
	content: {
		width: '100%',
		overflow: 'auto',
		flexGrow: 1,
		backgroundColor: theme.palette.grey[ 300 ],
		height: 'calc(100% - 56px)',
		maxHeight: 'calc(100% - 56px)',
		marginTop: 56,
		[ theme.breakpoints.up('sm') ]: {
			height: 'calc(100% - 64px)',
			maxHeight: 'calc(100% - 64px)',
			marginTop: 64,
		},
		position: 'relative',
	},
});



class Layout extends React.Component {
	state = {
		menuOpen: true,
	};

	componentDidMount = () => {
		setTimeout(() => {
			this.setState({ menuOpen: false });
		}, 750);
	};


	toggleMenu = () => {
		this.setState({ menuOpen: !this.state.menuOpen });
	};


	closeNotification = () => {
		this.props.setState({ notifyOpen: false });
	};


	render() {
		const classes = this.props.classes;
		let loc = this.props.location.pathname.split('/')[ 1 ] || null;
		let auth = !!this.props.auth.authenticated;

		return (
			<div className={classes.root}>
				<div className={classes.appFrame}>
					<AppBar
						className={classNames(classes.appBar, (this.state.menuOpen && auth) && classes.appBarShift, auth && classes.appBarAuth)}
					>
						<Toolbar>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
								noWrap
							>
								{this.props.layout.appTitle}
							</Typography>
							{auth ?
								<Notifications />
								: null
							}
							{auth ?
								<Button classes={{ root: classes.userButton }}>
									<Avatar className={classes.avatar}>{this.props.appData.UserInitials}</Avatar>
									<Typography
										variant="subtitle1"
										color="inherit"
										noWrap
									>
										{this.props.appData.UserName}
									</Typography>
								</Button>
								: null
							}
						</Toolbar>
					</AppBar>
					{auth ?
						<MainMenu
							isOpen={this.state.menuOpen}
							selectedItem={loc}
							toggle={this.toggleMenu}
						/> : null}
					<div className={classes.content}>
						{this.props.children}
					</div>
				</div>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={this.props.layout.notifyOpen}
					autoHideDuration={this.props.layout.notifyDuration}
					onClose={this.closeNotification}
					message={this.props.layout.notifyText}
				/>


				<BroadcastDialog />


			</div>
		);
	}
}



Layout.propTypes = {
	classes: PropTypes.object.isRequired,
};


const mapStateToProps = state => {
	return {
		layout: state.layout,
		auth: state.auth,
		appData: state.appData,
	};
};


const mapDispatchToProps = dispatch => {
	return {
		setState: (data) => {
			dispatch(actions.layout.setState(data));
		},
	}
};


Layout = withStyles(styles)(Layout);

export default connect(mapStateToProps, mapDispatchToProps)(Layout);